import { useEffect } from 'react'
import { workspaceSidebarStorageKey } from 'v2/shared/utils/workspace-sidebar-storage'
import { getLocalAuth } from 'v2/utils'
import { useFeatureFlags } from './use-feature-flags'

const readRemembered = (key: string | undefined) => {
  try {
    return key ? localStorage.getItem(key) === 'true' : false
  } catch {
    return false
  }
}

/**
 * Whether the workspace sidebar and header replace the old ones. Flags read false until they
 * load, so an org that had the flag keeps it meanwhile instead of flashing the old UI.
 */
export const useWorkspaceSidebarEnabled = () => {
  const { workspaceSidebarEnabled, isInitialData } = useFeatureFlags()
  const orgUuid = getLocalAuth().organization_uuid
  const key = orgUuid ? workspaceSidebarStorageKey(orgUuid) : undefined

  // Only the positive case is stored, so a flag-off org never gets a key.
  useEffect(() => {
    if (!key || isInitialData) return
    try {
      if (workspaceSidebarEnabled) localStorage.setItem(key, 'true')
      else localStorage.removeItem(key)
    } catch {
      // Storage can be unavailable; the flag still decides once it loads.
    }
  }, [key, isInitialData, workspaceSidebarEnabled])

  return isInitialData ? readRemembered(key) : !!workspaceSidebarEnabled
}
